import React from 'react';
export function SEOStrip() {
  return <div className="bg-atomic-charcoal text-gray-400 text-xs py-2 border-b border-white/5" data-id="element-365">
      <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-366">
        <p data-id="element-367">
          DTF Printing & Shipping, Custom Apparel, and Workwear for Businesses
          and Teams Nationwide
        </p>
      </div>
    </div>;
}